<template>
  <div class="pain py-80px">
    <div class="block-content">
      <block-title :en="pain.title.en" :title="pain.title.value" :sub="pain.title.sub"></block-title>

      <div class="card-container flex justify-between mt-60px gap-32px">
        <div class="card-item flex-col w-405px bg-#f2f7fd p-40px" v-for="item in pain.list" :key="item.title">
          <img class="wh-64px" :src="item.icon" alt="" />
          <div class="title text-#333 text-24px font-bold mt-32px whitespace-nowrap">{{ item.title }}</div>
          <div class="value text-#333 opacity-70 text-16px mt-18px line-height-28px">{{ item.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['globalData']),
    pain() {
      return this.globalData['tobacco-intelligent-logistics-distribution'].pain;
    }
  }
};
</script>

<style lang="scss" scoped>
.pain {
  * {
    box-sizing: border-box;
  }
  .card-item {
    min-height: 280px;
    border-radius: 8px;
    transition: all 0.3s;
    // &:hover {
    //   transform: translateY(-8px);
    //   box-shadow: 5px 8px 20px 0 #dadada;
    // }
  }
}
</style>
